// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"style-module--checkbox--j-cEw","container":"style-module--container--2eTAD","label":"style-module--label--1DGYg"};